import {Action, ActionReducer, createReducer, on} from '@ngrx/store';
import {MetricsConsentAutoCorrectionState} from './metricsConsentAutoCorrection';
import {
  disableMetricsConsentAutoCorrection,
  disableMetricsConsentAutoCorrectionSuccess,
  enableMetricsConsentAutoCorrection,
  enableMetricsConsentAutoCorrectionSuccess,
  initMetricsConsentAutoCorrectionSuccess
} from './metricsConsentAutoCorrection.actions';
import {TypedAction} from '@ngrx/store/src/models';

const _reducer: ActionReducer<MetricsConsentAutoCorrectionState> = createReducer(
  { status: 'not-configured', buttonIcon: 'auto_fix_off', enabled: false, loading: false, processing: false } as MetricsConsentAutoCorrectionState,
  on(initMetricsConsentAutoCorrectionSuccess, (state: MetricsConsentAutoCorrectionState, action: TypedAction<string> & { status: 'not-configured' | 'off' | 'on', buttonIcon: 'auto_fix_off' | 'auto_fix_normal' }): MetricsConsentAutoCorrectionState => {
    return {
      ...state,
      status: action.status,
      enabled: action.status === 'on',
      buttonIcon: action.buttonIcon
    }
  }),
  on(enableMetricsConsentAutoCorrection, (state: MetricsConsentAutoCorrectionState): MetricsConsentAutoCorrectionState => {
    return {
      ...state,
      loading: true
    }
  }),
  on(enableMetricsConsentAutoCorrectionSuccess, (state: MetricsConsentAutoCorrectionState): MetricsConsentAutoCorrectionState => {
    return {
      ...state,
      status: 'on',
      enabled: true,
      buttonIcon: 'auto_fix_normal',
      loading: false
    };
  }),
  on(disableMetricsConsentAutoCorrection, (state: MetricsConsentAutoCorrectionState): MetricsConsentAutoCorrectionState => {
    return {
      ...state,
      loading: true
    }
  }),
  on(disableMetricsConsentAutoCorrectionSuccess, (state: MetricsConsentAutoCorrectionState): MetricsConsentAutoCorrectionState => {
    return {
      ...state,
      status: 'off',
      enabled: false,
      buttonIcon: 'auto_fix_off',
      loading: false
    };
  })
);

export const metricsConsentAutoCorrectionReducer: ActionReducer<MetricsConsentAutoCorrectionState> = (state: MetricsConsentAutoCorrectionState, action: Action) => {
  return _reducer(state, action);
};
